import axios from 'axios';

// Alla miljöer (inkl. npm run serve) använder produktions-CMS:et.
// Sätt VUE_APP_CMS_URL för att peka mot en lokal Strapi vid behov.
export const CMS_URL =
  process.env.VUE_APP_CMS_URL || 'https://cms2.lagenhetsbyte.se';

// Strapis preview öppnar frontenden med ?preview=true. Då hämtas draft-
// versionen i stället för den publicerade, så redaktören ser sina osparade
// ändringar. Läses en gång per sidladdning.
export function isPreviewMode() {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('preview') === 'true';
}

// Hämtar från Strapi 5-API:t. Returnerar svarskuvertet { data, meta }.
// Endpoints är konfigurerade server-side att returnera fullt populerat
// innehåll, så inga populate-parametrar behövs här.
export async function cmsGet(path, params = {}) {
  const query = isPreviewMode() ? { ...params, status: 'draft' } : params;
  const response = await axios.get(`${CMS_URL}/api${path}`, { params: query });
  return response.data;
}
